import { formatSymbol } from "@/utils/i18n/format-symbol";

export const stockSentiment = {
  zh: {
    stockSentimentTitle: (symbol: string) => `${formatSymbol(symbol)} 個股情緒`,
  },
  en: {
    stockSentimentTitle: (symbol: string) =>
      `${formatSymbol(symbol)} Stock Sentiment`,
  },
};
